module.exports = __webpack_public_path__ + "static/media/image2.2a07f97b.png";